/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SapUserDataResponse
 */
export interface SapUserDataResponse {
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    employmentCategory?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SapUserDataResponse
     */
    employmentEndDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SapUserDataResponse
     */
    employmentStartDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    employmentStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    fullname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    initials?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobCode2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    jobTitleCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    mdirCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    organizationalUnit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    personCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    personGroup?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sapFirstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sapSurname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sapUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sectionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SapUserDataResponse
     */
    sectionName?: string | null;
}

/**
 * Check if a given object implements the SapUserDataResponse interface.
 */
export function instanceOfSapUserDataResponse(value: object): value is SapUserDataResponse {
    return true;
}

export function SapUserDataResponseFromJSON(json: any): SapUserDataResponse {
    return SapUserDataResponseFromJSONTyped(json, false);
}

export function SapUserDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SapUserDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'employmentCategory': json['employmentCategory'] === undefined ? undefined : json['employmentCategory'] === null ? null : json['employmentCategory'],
        'employmentEndDate': json['employmentEndDate'] === undefined ? undefined : json['employmentEndDate'] === null ? null : (new Date(json['employmentEndDate'])),
        'employmentStartDate': json['employmentStartDate'] === undefined ? undefined : json['employmentStartDate'] === null ? null : (new Date(json['employmentStartDate'])),
        'employmentStatus': json['employmentStatus'] === undefined ? undefined : json['employmentStatus'] === null ? null : json['employmentStatus'],
        'fullname': json['fullname'] === undefined ? undefined : json['fullname'] === null ? null : json['fullname'],
        'initials': json['initials'] === undefined ? undefined : json['initials'] === null ? null : json['initials'],
        'jobCode': json['jobCode'] === undefined ? undefined : json['jobCode'] === null ? null : json['jobCode'],
        'jobCode2': json['jobCode2'] === undefined ? undefined : json['jobCode2'] === null ? null : json['jobCode2'],
        'jobTitle': json['jobTitle'] === undefined ? undefined : json['jobTitle'] === null ? null : json['jobTitle'],
        'jobTitleCode': json['jobTitleCode'] === undefined ? undefined : json['jobTitleCode'] === null ? null : json['jobTitleCode'],
        'mdirCity': json['mdirCity'] === undefined ? undefined : json['mdirCity'] === null ? null : json['mdirCity'],
        'organizationalUnit': json['organizationalUnit'] === undefined ? undefined : json['organizationalUnit'] === null ? null : json['organizationalUnit'],
        'personCity': json['personCity'] === undefined ? undefined : json['personCity'] === null ? null : json['personCity'],
        'personGroup': json['personGroup'] === undefined ? undefined : json['personGroup'] === null ? null : json['personGroup'],
        'sapFirstname': json['sapFirstname'] === undefined ? undefined : json['sapFirstname'] === null ? null : json['sapFirstname'],
        'sapSurname': json['sapSurname'] === undefined ? undefined : json['sapSurname'] === null ? null : json['sapSurname'],
        'sapUserId': json['sapUserId'] === undefined ? undefined : json['sapUserId'] === null ? null : json['sapUserId'],
        'sectionCode': json['sectionCode'] === undefined ? undefined : json['sectionCode'] === null ? null : json['sectionCode'],
        'sectionName': json['sectionName'] === undefined ? undefined : json['sectionName'] === null ? null : json['sectionName'],
    };
}

export function SapUserDataResponseToJSON(json: any): SapUserDataResponse {
    return SapUserDataResponseToJSONTyped(json, false);
}

export function SapUserDataResponseToJSONTyped(value?: SapUserDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employmentCategory': value['employmentCategory'],
        'employmentEndDate': value['employmentEndDate'] == null ? value['employmentEndDate'] : value['employmentEndDate'].toISOString(),
        'employmentStartDate': value['employmentStartDate'] == null ? value['employmentStartDate'] : value['employmentStartDate'].toISOString(),
        'employmentStatus': value['employmentStatus'],
        'fullname': value['fullname'],
        'initials': value['initials'],
        'jobCode': value['jobCode'],
        'jobCode2': value['jobCode2'],
        'jobTitle': value['jobTitle'],
        'jobTitleCode': value['jobTitleCode'],
        'mdirCity': value['mdirCity'],
        'organizationalUnit': value['organizationalUnit'],
        'personCity': value['personCity'],
        'personGroup': value['personGroup'],
        'sapFirstname': value['sapFirstname'],
        'sapSurname': value['sapSurname'],
        'sapUserId': value['sapUserId'],
        'sectionCode': value['sectionCode'],
        'sectionName': value['sectionName'],
    };
}

